import { Fragment, useEffect, useMemo, useState } from 'react';
import { Alert } from '@cluey/cluey-components';

import { getSessionsInViewByIndex } from '../../../../util/helpers';
import { Loader } from '../../../../components/Loader';
import RecordsPagination from '../../../../components/hub/RecordsPagination';
import { NO_OF_SESSIONS_PER_PAGE } from '../../../../util/constants';
import useSessionContext from '../useSessionContext';
import CancelledSessionCard from '../../../../components/hub/sessions/CancelledSessionCard';

const CancelledSessions = () => {
  const {
    filteredSessions: { cancelled: cancelledSessions = [] },
    fetchSessionIsLoading: cancelledSessionsLoading,
    fetchSessionIsError: cancelledSessionsError,
  } = useSessionContext();

  const [{ sessionsInView, startIndex }, setSessionDetails] = useState({
    allSessions: [],
    totalSessions: 0,
    sessionsInView: [],
    startIndex: 0,
  });

  const memoizedCancelledSessions = useMemo(() => {
    if (!cancelledSessions?.length) return [];
    return cancelledSessions;
  }, [cancelledSessions]);

  useEffect(() => {
    if (memoizedCancelledSessions.length > 0) {
      const sessionsInView = getSessionsInViewByIndex(memoizedCancelledSessions, startIndex);

      setSessionDetails((current) => {
        if (
          current.totalSessions === memoizedCancelledSessions.length &&
          JSON.stringify(current.sessionsInView) === JSON.stringify(sessionsInView)
        ) {
          return current;
        }
        return {
          allSessions: memoizedCancelledSessions,
          totalSessions: memoizedCancelledSessions.length,
          startIndex,
          sessionsInView,
        };
      });
    } else {
      setSessionDetails((current) => {
        if (current.totalSessions === 0 && current.sessionsInView.length === 0) {
          return current;
        }
        return {
          allSessions: [],
          totalSessions: 0,
          sessionsInView: [],
          startIndex: 0,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelledSessions]);

  const handlePaginationClick = (newStartIndex) => {
    setSessionDetails((current) => {
      return {
        ...current,
        sessionsInView: getSessionsInViewByIndex(current.allSessions, newStartIndex),
        startIndex: newStartIndex,
      };
    });
  };

  return (
    <Fragment>
      {cancelledSessionsLoading ? (
        <Loader />
      ) : (
        <Fragment>
          {cancelledSessionsError && (
            <Alert type="error" body="There was an error retrieving your cancelled sessions" />
          )}
          {!cancelledSessionsError &&
            (memoizedCancelledSessions?.length === 0 ? (
              <p>You have no cancelled sessions.</p>
            ) : (
              <Fragment>
                <div className="flex flex-col gap-y-2">
                  {sessionsInView.map((session) => (
                    <CancelledSessionCard key={`${session.studentSessionId}-${session.startTime}`} session={session} />
                  ))}
                </div>
                <RecordsPagination
                  recordsTotal={cancelledSessions?.length}
                  noOfRecordsPerPage={NO_OF_SESSIONS_PER_PAGE}
                  handlePaginationClick={handlePaginationClick}
                  pageIndex={startIndex}
                />
              </Fragment>
            ))}
        </Fragment>
      )}
    </Fragment>
  );
};

export default CancelledSessions;
